import { IFeatures } from "../../utils/interfaces";

import { currentFeatures } from "../../configs/Settings";

import { Note } from "@mui/icons-material";
import { EHRRecords } from "./EHRRecords";

export function useEHRRecords() {

  const configs: IFeatures = {
    active: !currentFeatures.register,
    path: "/summary",
    icon: Note,
    text: "Registros eletrônicos",

    sideMenu: false,
    avatarMenu: false,

    component: () => <EHRRecords />,
  };

  return configs;
}
